import React from 'react';
import { RouteWithContext as Route } from './Route';
import { jsx as _jsx } from "react/jsx-runtime";
const updateStaticContext = (staticContext, _ref) => {
  let {
    statusCode,
    url
  } = _ref;
  // there is no `staticContext` on the client, so
  // we need to guard against that here
  if (!staticContext) return;

  // we need to mutate the context object
  if (typeof statusCode === 'number') {
    staticContext.statusCode = statusCode;
  }
  if (typeof url === 'string') {
    staticContext.url = url;
  }
};

/**
 * Render a catch-all route which updates static context.
 * Mutates the `routerContext.staticContext` to indicate statusCode. Useful while server side
 * rendering to detect when a different status code needs to be used.
 *
 * @see https://v5.reactrouter.com/web/guides/server-rendering/adding-app-specific-context-information
 */
const StaticContextRoute = props => {
  const {
    render: _render,
    statusCode
  } = props;
  return /*#__PURE__*/_jsx(Route, {
    render: contextRouter => {
      updateStaticContext(contextRouter.staticContext, {
        statusCode
      });
      return _render(contextRouter);
    }
  });
};
export default StaticContextRoute;